import React from 'react';
import {PopupState} from '@src/@types/components/Popup';

export const PopupContext = React.createContext<[
    () => PopupState,
    React.Dispatch<React.SetStateAction<PopupState>>
] | [() => null, null]>([() => null, null]);
